import request from "@/utils/request.js"

// 通过会员标签-查询已选中的会员列表
export const listStoreMemberTagChecked = (pageData, id) => {
    return request.get(`/storeMember/tag/checked/${pageData.page}/${pageData.pageSize}/${id}`)
}

// 通过会员标签-查询俱乐部会员列表
export const getStoreMemberListWithTag = (pageData, formData) => {
    return request.post(`/storeMember/tag/${pageData.page}/${pageData.pageSize}`, formData)
}

// 通过店铺ID查询-查询会员列表
export const getStoreMemberListWithTagAdmin = (pageData, formData, storeId) => {
    return request.post(`/storeMember/tag/${pageData.page}/${pageData.pageSize}/${storeId}`, formData)
}

// 查询会员总数
export const getStoreMemberTotal = () => {
    return request.get(`/storeMember/member/total`)
}

// 通过店铺ID查询-会员总数
export const getStoreMemberTotalAdmin = (storeId) => {
    return request.get(`/storeMember/member/total/${storeId}`)
}
